import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GroupUI } from '@src/models';

@Component({
  selector: 'new-list-item-group',
  templateUrl: './list-item-group.component.html',
  styleUrls: ['../styles/list-item.component.scss', './list-item-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemGroupComponent {
  @Input() set item(data: GroupUI | undefined) {
    this.data = data;
  }

  @Input() selectedId?: string;

  data?: GroupUI;
}
